var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodataImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 180,
    viewBox: "0 0 258 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.737 180C199.837 180 257.474 176.784 257.474 172.817C257.474 168.85 199.837 165.634 128.737 165.634C57.6375 165.634 0 168.85 0 172.817C0 176.784 57.6375 180 128.737 180Z",
    fill: "url(#paint0_linear_10942_214473)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.221 111.537C215.145 108.868 212.505 108.905 212.505 108.905C213.742 111.702 217.221 111.537 217.221 111.537ZM211.659 115.782C213.899 115.386 213.89 112.804 213.89 112.804C211.722 113.839 211.659 115.782 211.659 115.782ZM218.839 106.764C216.765 102.404 212.859 102.272 212.859 102.272C213.65 106.777 218.839 106.764 218.839 106.764ZM198.989 107.998C195.605 107.548 194.021 109.811 194.021 109.811C196.996 111.079 198.989 107.998 198.989 107.998ZM220.97 101.072C219.722 96.407 215.905 95.5672 215.905 95.5672C215.864 100.14 220.97 101.072 220.97 101.072ZM211.64 108.118C209.207 109.973 210.178 113.317 210.178 113.317C212.29 110.678 211.64 108.118 211.64 108.118ZM202.03 103.981C201.122 106.205 202.383 107.686 202.383 107.686C203.774 105.885 202.03 103.981 202.03 103.981ZM231.038 84.624C231.51 82.2686 229.993 81.0527 229.993 81.0527C228.967 83.0833 231.038 84.624 231.038 84.624ZM236.839 81.3686C233.44 81.6922 232.408 84.2551 232.408 84.2551C235.591 84.8195 236.839 81.3686 236.839 81.3686ZM228.499 87.039C228.867 83.6781 226.947 81.8657 226.947 81.8657C225.887 84.7349 228.499 87.039 228.499 87.039ZM223.228 95.5499C221.152 92.8816 218.511 92.918 218.511 92.918C219.749 95.7151 223.228 95.5499 223.228 95.5499ZM227.081 89.6924C225.9 86.5247 223.37 85.7677 223.37 85.7677C223.713 88.8079 227.081 89.6924 227.081 89.6924ZM225.183 92.9031C223.936 88.2382 220.119 87.3984 220.119 87.3984C220.078 91.9715 225.183 92.9031 225.183 92.9031ZM207.588 104.573C205.428 107.216 206.523 109.753 206.523 109.753C209.163 107.887 207.588 104.573 207.588 104.573ZM218.705 118.91C222.522 121.43 226.078 117.65 226.078 117.65C221.484 116.162 218.705 118.91 218.705 118.91ZM198.153 113.708C201.343 114.234 202.548 110.768 202.548 110.768C199.154 111.133 198.153 113.708 198.153 113.708ZM222.386 108.536C224.875 110.6 227.665 108.217 227.665 108.217C224.55 106.819 222.386 108.536 222.386 108.536ZM225.781 97.5638C228.885 100.923 233.241 98.1038 233.241 98.1038C229.137 95.5607 225.781 97.5638 225.781 97.5638ZM233.541 86.4573C235.635 87.3471 237.035 85.1783 237.035 85.1783C234.654 84.8636 233.541 86.4573 233.541 86.4573ZM230.957 89.2192C231.951 91.2665 234.432 90.5519 234.432 90.5519C232.844 88.7495 230.957 89.2192 230.957 89.2192ZM228.547 93.1981C230.97 95.0642 233.948 93.2577 233.948 93.2577C230.849 91.9048 228.547 93.1981 228.547 93.1981ZM223.638 103.058C226.741 106.418 231.098 103.598 231.098 103.598C226.993 101.055 223.638 103.058 223.638 103.058ZM204.824 122.218C207.652 123.785 209.952 120.927 209.952 120.927C206.633 120.129 204.824 122.218 204.824 122.218ZM208.268 116.546C204.873 116.911 203.872 119.486 203.872 119.486C207.062 120.012 208.268 116.546 208.268 116.546ZM205.397 113.24C202.996 113.13 202.025 114.814 202.025 114.814C204.187 115.521 205.397 113.24 205.397 113.24ZM231.81 86.2421L231.463 85.9555C221.117 98.4519 216.771 114.552 214.947 125.857C214.712 127.317 214.512 128.736 214.341 130.105C214.017 128.044 213.33 124.54 212.004 120.943C209.259 113.495 205.035 109.039 199.789 108.058L199.707 108.501C211.562 110.719 213.95 130.251 214.13 131.9C213.123 141.067 213.448 147.535 213.452 147.612L213.902 147.588C213.897 147.511 213.575 141.088 214.576 131.973L214.591 131.972C214.591 131.968 214.588 131.944 214.584 131.899C214.792 130.012 215.056 128.014 215.392 125.93C217.206 114.678 221.527 98.6611 231.81 86.2421ZM225.354 113.903C222.255 112.551 219.953 113.844 219.953 113.844C222.377 115.71 225.354 113.903 225.354 113.903ZM204.131 124.72C206.849 128.399 211.488 126.073 211.488 126.073C207.686 123.096 204.131 124.72 204.131 124.72Z",
    fill: "url(#paint1_linear_10942_214473)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.631 153.538C216.704 154.178 213.852 162.094 211.099 159.727C210.956 159.604 210.84 159.483 210.744 159.348C209.081 157.055 214.482 153.333 214.457 140.97C214.448 133.147 214.02 118.68 219.647 117.314C224.464 116.148 222.785 127.946 229.656 126.751C234.651 125.884 228.036 116.778 232.478 115.011C237.397 113.054 237.269 122.547 241.425 119.941C245.572 117.336 246.905 109.004 250.655 111.286C250.714 111.321 250.769 111.361 250.819 111.396C254.282 113.735 250.668 119.164 248.124 122.605C245.541 126.101 244.528 126.989 245.665 127.695C246.802 128.402 253.275 127.447 252.872 131.578C252.464 135.713 241.487 134.977 238.057 139.352C234.623 143.73 245.265 141.569 243 146.557C241.692 149.423 236.052 153.226 229.631 153.538Z",
    fill: "url(#paint2_linear_10942_214473)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.206 146.098L224.885 145.178L234.198 133.932L234.2 133.948L244.979 132.151L234.988 132.978L245.864 119.844L239.123 127.221L235.994 121.206L238.489 127.915L228.205 139.17L220.996 126.707L227.605 139.828L214.704 154.05L216.066 155.236L224.206 145.999L238.206 146.098Z",
    fill: "url(#paint3_linear_10942_214473)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.472 147.548C190.501 147.669 190.539 147.789 190.572 147.911C191.884 152.337 194.863 157.504 200.231 162.813C203.782 166.326 207.692 168.184 211.394 169.082C211.487 169.105 211.579 169.128 211.673 169.147C212.009 169.224 212.343 169.293 212.675 169.356C219.96 170.722 227.435 168.149 232.603 162.837C236.155 159.186 239.832 154.667 238.885 152.402C238.852 152.311 238.806 152.225 238.753 152.141C238.748 152.128 238.739 152.118 238.733 152.109C236.363 148.563 231.3 149.392 229.431 148.477C229.34 148.431 229.258 148.382 229.184 148.329C229.118 148.282 229.055 148.23 229.002 148.174C227.652 146.768 233.789 143.732 233.698 139.091C233.692 138.795 233.665 138.52 233.622 138.266C233.606 138.156 233.584 138.052 233.559 137.948C232.747 134.624 228.709 135.122 228.292 133.603C228.267 133.526 228.255 133.449 228.252 133.365C228.249 133.278 228.25 133.18 228.252 133.078C228.314 131.417 229.164 128.007 229.92 124.179C229.944 124.067 229.968 123.951 229.988 123.838C230.664 120.365 231.24 116.583 231.062 113.463C231.055 113.363 231.048 113.267 231.04 113.17C230.823 110.226 229.901 107.913 227.701 107.082C227.633 107.053 227.565 107.029 227.495 107.007C227.473 106.998 227.448 106.992 227.425 106.986C225.153 106.274 222.864 107.069 220.73 108.724C220.614 108.814 220.497 108.907 220.382 109.004L220.381 109.008C216.234 112.434 212.747 119.049 211.275 124.014C211.227 124.176 211.183 124.338 211.141 124.493C210.935 125.237 210.778 125.938 210.675 126.582C210.112 130.09 208.961 133.778 207.707 136.688C207.656 136.816 207.597 136.944 207.542 137.072C206.335 139.789 205.05 141.751 204.111 142.115C204.046 142.138 203.982 142.158 203.921 142.167C203.892 142.171 203.864 142.173 203.834 142.169C202.052 142.168 196.388 134.799 192.862 135.636C192.77 135.656 192.676 135.685 192.589 135.718C192.161 135.877 191.77 136.17 191.425 136.629C189.767 138.845 189.131 142.745 190.472 147.548Z",
    fill: "#433D87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.472 147.548C190.501 147.669 190.539 147.789 190.572 147.911C192.604 148.895 194.88 149.592 196.832 150.072C199.503 150.729 201.578 150.979 201.616 150.984L201.624 150.919C206.565 155.754 211.689 158.186 212.756 158.661C211.931 164.195 211.496 168.109 211.394 169.083C211.38 169.222 211.372 169.302 211.368 169.317L211.652 169.347C211.652 169.332 211.661 169.263 211.673 169.148C211.736 168.558 211.94 166.688 212.305 163.921C213.933 163.475 231.752 158.484 238.885 152.403C238.852 152.313 238.806 152.227 238.753 152.142C235.621 154.831 230.365 157.312 225.345 159.277C225.683 157.967 227.484 151.166 229.432 148.478L229.185 148.33C227.048 151.31 225.163 158.819 225.015 159.404C219.073 161.712 213.54 163.284 212.345 163.616C212.968 158.918 214.035 151.779 215.624 143.891C215.854 143.963 216.088 144.033 216.319 144.09C224.08 145.998 231.823 139.824 233.622 138.267C233.606 138.157 233.584 138.053 233.559 137.949C232.619 138.776 229.272 141.589 225.318 143.06C225.603 141.789 226.893 136.22 228.292 133.604C228.267 133.527 228.255 133.45 228.252 133.366C228.249 133.279 228.25 133.181 228.252 133.079C226.738 135.859 225.174 142.383 224.997 143.182C222.2 144.171 218.957 144.624 215.681 143.611C216.884 137.662 218.383 131.307 220.214 125.265C221.306 125.301 226.962 125.425 229.919 124.18C229.943 124.068 229.968 123.952 229.987 123.839C227.239 125.095 221.558 125.013 220.3 124.979C221.368 121.48 222.548 118.091 223.847 114.952L223.873 114.99C223.905 114.971 226.794 113.029 231.062 113.465C231.055 113.365 231.048 113.269 231.04 113.172C227.458 112.826 224.834 114.105 223.997 114.58C225.139 111.855 226.371 109.325 227.701 107.083C227.633 107.054 227.565 107.03 227.495 107.008C227.473 106.999 227.448 106.993 227.425 106.987C225.55 110.166 223.86 113.917 222.35 117.98C221.972 116.99 219.992 111.601 220.73 108.725C220.614 108.815 220.496 108.908 220.382 109.005L220.381 109.009C219.79 112.33 222.037 117.962 222.151 118.249L222.273 118.201C220.34 123.442 218.695 129.187 217.32 134.877C216.56 133.853 212.897 128.766 211.275 124.015C211.227 124.177 211.184 124.339 211.142 124.494C213.033 129.715 217.187 135.175 217.232 135.237L217.236 135.234C216.311 139.079 215.51 142.895 214.82 146.502C213.796 145.594 209.363 141.463 207.707 136.688C207.656 136.817 207.597 136.944 207.542 137.072C209.38 142.017 214.04 146.204 214.756 146.829C213.955 151.062 213.305 155.003 212.801 158.365C211.827 157.928 208.327 156.238 204.459 153.072C204.525 152.466 205.09 147.112 204.111 142.115C204.046 142.138 203.982 142.158 203.922 142.167C203.893 142.172 203.865 142.173 203.835 142.169C204.737 146.79 204.311 151.722 204.195 152.853C199.76 149.159 194.914 143.533 192.862 135.636C192.77 135.657 192.677 135.685 192.59 135.719C194.253 142.124 197.737 147.045 201.365 150.663C200.082 150.486 194.693 149.649 190.472 147.548Z",
    fill: "url(#paint4_linear_10942_214473)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.04 52.1978L214.012 58.5661L213.916 166.253C213.915 167.733 212.712 168.929 211.232 168.924L84.5112 168.405V62.5492C84.5112 60.068 86.5281 58.0589 89.0099 58.069L132.654 58.2484L182.384 58.4535L184.269 54.9591L186.684 50.4902C187.227 49.4735 188.301 48.8238 189.48 48.8381L210.794 48.9156C212.6 48.9293 214.04 50.3836 214.04 52.1978Z",
    fill: "#9806C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.66 116.828H98.6299C96.796 116.828 95.3096 115.341 95.3096 113.507V50.1621C95.3096 48.3282 96.796 46.8418 98.6299 46.8418H158.66C160.493 46.8418 161.98 48.3282 161.98 50.1621V113.507C161.98 115.341 160.493 116.828 158.66 116.828Z",
    fill: "#433D87"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.248 56.6904C114.001 56.6904 112.99 57.7018 112.99 58.9493C112.99 60.1967 114.001 61.2081 115.248 61.2081C116.496 61.2081 117.507 60.1967 117.507 58.9493C117.507 57.7018 116.496 56.6904 115.248 56.6904ZM142.041 56.6904C140.793 56.6904 139.782 57.7018 139.782 58.9493C139.782 60.1967 140.793 61.2081 142.041 61.2081C143.288 61.2081 144.299 60.1967 144.299 58.9493C144.299 57.7018 143.288 56.6904 142.041 56.6904ZM128.645 69.9909C124.461 69.9909 120.651 71.3283 118.454 73.5687C118.104 73.9245 118.11 74.4967 118.466 74.8465C118.642 75.0194 118.87 75.1052 119.099 75.1052C119.333 75.1052 119.566 75.0146 119.743 74.834C121.58 72.9614 124.991 71.798 128.645 71.798C132.299 71.798 135.709 72.9614 137.545 74.834C137.894 75.1898 138.466 75.1958 138.823 74.8465C139.179 74.4973 139.185 73.9257 138.836 73.5687C136.638 71.3289 132.829 69.9909 128.645 69.9909Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M209.684 170.48L73.2639 171.031C71.4353 171.038 69.8118 169.873 69.2254 168.143L47.2477 102.57L42.1363 87.328C41.2113 84.5888 43.2449 81.7506 46.132 81.7434L49.4219 81.7291L182.559 81.1856C184.38 81.1784 186.011 82.3436 186.59 84.0804L212.19 160.434L212.846 162.382L213.687 164.896C214.605 167.635 212.572 170.466 209.684 170.48Z",
    fill: "#CD47F3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M193.348 96.9603C199.642 88.8087 198.136 77.0986 189.984 70.8049C181.832 64.5113 170.122 66.0174 163.829 74.169C157.535 82.3205 159.041 94.0307 167.193 100.324C175.344 106.618 187.054 105.112 193.348 96.9603Z",
    fill: "#BBE5FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.104 78.7051L171.739 93.0706",
    stroke: "#8AB8E2",
    strokeWidth: 3.5536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.104 93.0706L171.739 78.7051",
    stroke: "#8AB8E2",
    strokeWidth: 3.5536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6323 0C60.5272 0 63.2032 2.34885 63.2032 6.12514C63.2032 10.4658 60.2006 12.2503 56.0381 12.2503L55.9487 15.0747H53.5998L53.4806 10.377H54.343C57.7325 10.377 60.6166 9.72262 60.6166 6.12514C60.6166 3.74649 59.0706 2.26005 56.6621 2.26005C54.2238 2.26005 52.7076 3.65708 52.7076 5.97674H50.1501C50.1209 2.37865 52.7374 0 56.6323 0ZM54.759 21.1695C53.7184 21.1695 52.9156 20.3673 52.9156 19.326C52.9156 18.2848 53.7178 17.4826 54.759 17.4826C55.7401 17.4826 56.5429 18.2848 56.5429 19.326C56.5429 20.3673 55.7401 21.1695 54.759 21.1695Z",
    fill: "url(#paint5_linear_10942_214473)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.722 17.9953C171 16.8426 173.26 17.4255 174.377 19.6337C175.661 22.1726 174.433 24.1043 171.998 25.3356L172.781 27.014L171.408 27.7089L169.949 24.9965L170.453 24.7414C172.435 23.739 173.928 22.5034 172.864 20.3983C172.16 19.0079 170.816 18.5954 169.408 19.3077C167.982 20.0288 167.508 21.2947 168.195 22.6512L166.699 23.4076C165.617 21.3126 166.444 19.1473 168.722 17.9953ZM173.889 30.9309C173.28 31.2391 172.573 31.0066 172.265 30.3975C171.958 29.7896 172.19 29.0821 172.798 28.774C173.373 28.4831 174.079 28.7162 174.387 29.3247C174.695 29.9338 174.462 30.6407 173.889 30.9309Z",
    fill: "url(#paint6_linear_10942_214473)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.271 27.6897L111.4 32.6657C110.615 33.3308 109.435 33.2337 108.77 32.4488L100.666 22.8877L100.926 19.0559L106.179 14.6038C106.964 13.9386 108.144 14.0358 108.809 14.8207L117.488 25.0595C118.154 25.8444 118.056 27.0239 117.271 27.6897ZM101.002 22.7774L109.021 32.2372C109.569 32.8844 110.542 32.9649 111.189 32.416L117.06 27.4399C117.707 26.891 117.788 25.9183 117.239 25.2711L108.56 15.0323C108.011 14.3851 107.038 14.3046 106.391 14.8535L101.244 19.2163L101.002 22.7774Z",
    fill: "url(#paint7_linear_10942_214473)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.085 19.1357L102.803 21.1628L100.834 22.8322L101.085 19.1357Z",
    fill: "url(#paint8_linear_10942_214473)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.344 17.7325L103.04 22.2282L102.889 22.05L108.193 17.5537L108.344 17.7325Z",
    fill: "url(#paint9_linear_10942_214473)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.25 18.8012L103.946 23.2975L103.795 23.1187L109.099 18.623L109.25 18.8012Z",
    fill: "url(#paint10_linear_10942_214473)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.157 19.8716L104.853 24.3672L104.702 24.189L110.006 19.6934L110.157 19.8716Z",
    fill: "url(#paint11_linear_10942_214473)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.064 20.9409L105.76 25.4366L105.609 25.2584L110.913 20.7627L111.064 20.9409Z",
    fill: "url(#paint12_linear_10942_214473)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.971 22.0108L106.667 26.5065L106.516 26.3283L111.82 21.832L111.971 22.0108Z",
    fill: "url(#paint13_linear_10942_214473)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.877 23.0805L107.573 27.5768L107.422 27.398L112.726 22.9023L112.877 23.0805Z",
    fill: "url(#paint14_linear_10942_214473)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.784 24.1499L108.48 28.6455L108.329 28.4673L113.633 23.9717L113.784 24.1499Z",
    fill: "url(#paint15_linear_10942_214473)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.691 25.2202L109.387 29.7159L109.235 29.5377L114.54 25.042L114.691 25.2202Z",
    fill: "url(#paint16_linear_10942_214473)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M229.11 55.7706L223.068 51.005C222.259 50.3679 222.12 49.1919 222.758 48.3844L230.519 38.5425L234.327 38.0371L239.734 42.3009C240.542 42.9381 240.681 44.114 240.044 44.9216L231.732 55.4613C231.094 56.2689 229.919 56.4078 229.11 55.7706ZM230.694 38.8495L223.015 48.587C222.489 49.2533 222.604 50.2224 223.271 50.7481L229.314 55.5138C229.98 56.0394 230.95 55.9244 231.475 55.2587L239.787 44.7195C240.312 44.0532 240.198 43.0835 239.532 42.5584L234.234 38.3804L230.694 38.8495Z",
    fill: "url(#paint17_linear_10942_214473)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.279 38.208L232.634 40.2946L230.607 38.6955L234.279 38.208Z",
    fill: "url(#paint18_linear_10942_214473)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M237.096 45.0428L231.637 40.7373L231.782 40.5537L237.241 44.8592L237.096 45.0428Z",
    fill: "url(#paint19_linear_10942_214473)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M236.228 46.1434L230.769 41.8379L230.914 41.6543L236.373 45.9598L236.228 46.1434Z",
    fill: "url(#paint20_linear_10942_214473)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M235.36 47.2459L229.9 42.9404L230.045 42.7568L235.505 47.0624L235.36 47.2459Z",
    fill: "url(#paint21_linear_10942_214473)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M234.491 48.3465L229.032 44.041L229.177 43.8574L234.636 48.163L234.491 48.3465Z",
    fill: "url(#paint22_linear_10942_214473)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M233.624 49.4465L228.164 45.1416L228.309 44.958L233.768 49.2635L233.624 49.4465Z",
    fill: "url(#paint23_linear_10942_214473)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M232.756 50.5487L227.296 46.2431L227.44 46.0596L232.9 50.3651L232.756 50.5487Z",
    fill: "url(#paint24_linear_10942_214473)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M231.887 51.6493L226.427 47.3437L226.572 47.1602L232.031 51.4657L231.887 51.6493Z",
    fill: "url(#paint25_linear_10942_214473)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M231.019 52.7508L225.559 48.4453L225.703 48.2617L231.163 52.5673L231.019 52.7508Z",
    fill: "url(#paint26_linear_10942_214473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10942_214473",
    x1: 236.386,
    y1: 172.817,
    x2: 17.2152,
    y2: 172.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10942_214473",
    x1: 220.737,
    y1: 81.027,
    x2: 211.153,
    y2: 111.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#45D8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C8BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10942_214473",
    x1: 210.426,
    y1: 135.531,
    x2: 252.889,
    y2: 135.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10942_214473",
    x1: 214.704,
    y1: 137.54,
    x2: 245.864,
    y2: 137.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F9CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10942_214473",
    x1: 241.078,
    y1: 143.481,
    x2: 193.553,
    y2: 131.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#45D8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C8BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10942_214473",
    x1: 56.6768,
    y1: 1.53567,
    x2: 56.6768,
    y2: 23.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10942_214473",
    x1: 170.561,
    y1: 16.73,
    x2: 170.561,
    y2: 32.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10942_214473",
    x1: 104.431,
    y1: 27.3293,
    x2: 113.149,
    y2: 19.9397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10942_214473",
    x1: 99.9746,
    y1: 21.8189,
    x2: 101.944,
    y2: 20.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10942_214473",
    x1: 102.964,
    y1: 22.1389,
    x2: 108.268,
    y2: 17.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10942_214473",
    x1: 103.871,
    y1: 23.2081,
    x2: 109.175,
    y2: 18.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10942_214473",
    x1: 104.778,
    y1: 24.2783,
    x2: 110.082,
    y2: 19.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10942_214473",
    x1: 105.685,
    y1: 25.3475,
    x2: 110.989,
    y2: 20.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10942_214473",
    x1: 106.591,
    y1: 26.4173,
    x2: 111.895,
    y2: 21.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10942_214473",
    x1: 107.498,
    y1: 27.4875,
    x2: 112.802,
    y2: 22.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10942_214473",
    x1: 108.405,
    y1: 28.5567,
    x2: 113.709,
    y2: 24.0608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10942_214473",
    x1: 109.311,
    y1: 29.6268,
    x2: 114.615,
    y2: 25.1309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10942_214473",
    x1: 226.914,
    y1: 43.1145,
    x2: 235.887,
    y2: 50.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10942_214473",
    x1: 231.429,
    y1: 37.6525,
    x2: 233.457,
    y2: 39.2513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10942_214473",
    x1: 231.709,
    y1: 40.6454,
    x2: 237.169,
    y2: 44.9508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10942_214473",
    x1: 230.841,
    y1: 41.7463,
    x2: 236.301,
    y2: 46.0517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10942_214473",
    x1: 229.973,
    y1: 42.8485,
    x2: 235.432,
    y2: 47.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10942_214473",
    x1: 229.104,
    y1: 43.9493,
    x2: 234.564,
    y2: 48.2547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10942_214473",
    x1: 228.236,
    y1: 45.0496,
    x2: 233.696,
    y2: 49.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10942_214473",
    x1: 227.368,
    y1: 46.1514,
    x2: 232.828,
    y2: 50.4568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10942_214473",
    x1: 226.5,
    y1: 47.2522,
    x2: 231.959,
    y2: 51.5576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10942_214473",
    x1: 225.631,
    y1: 48.3535,
    x2: 231.091,
    y2: 52.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7ECFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataImg);
export default __webpack_public_path__ + "static/media/nodata_img.470ce388621da9987402688e88170db2.svg";
export { ForwardRef as ReactComponent };